// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-container {
  width: 100%;
  height: 100vh;
  background: #0a131d;
  display: flex;
  align-items: center;
  justify-content: center;
}
.login-container .login-boxer {
  width: 380px;
  max-width: 90%;
}
.login-container .logo {
  max-width: 250px;
}
.login-ft {
  position: absolute;
  bottom: 15px;
  right: 15px;
  z-index: 1;
  color: #ffffff;
}
.user-dropdown {
  cursor: pointer;
}
.user-dropdown .user-label {
  color: #ffffff;
  margin: 0;
}
@media (max-width: 576px) {
  .user-dropdown .user-label {
    width: 40px;
  }
}
.header-content-main {
  padding-bottom: 10px;
}
.card-folder-item {
  overflow: hidden;
  cursor: pointer;
}
.card-folder-item .folder-item-container {
  width: 100%;
  overflow: hidden;
}
.card-folder-item .folder-item-container .folder-item-name {
  width: calc(100% - 25px);
}
.card-file-item {
  overflow: hidden;
}
.card-file-item .card-cover {
  object-fit: contain;
  object-position: center;
}
.card-file-item .card-cover-dox {
  height: 100px;
  width: 100%;
  font-size: 60px;
  display: flex !important;
}
.skeleton-file-media {
  width: 100% !important;
  height: 100% !important;
}
.skeleton-file-media .card-file-item {
  width: 100%;
  height: 100%;
}
.skeleton-file-media .card-cover-dox {
  font-size: 60px;
  color: #bfbfbf;
}
.skeleton-file-media .card-cover-dox {
  height: 100px;
  width: 100%;
  font-size: 60px;
  display: flex !important;
}
.attachment-detail-container .attachment-info {
  height: calc(100vh - 250px);
  overflow: auto;
}
.media-modal-container,
.media-model-detail-file {
  height: 96% !important;
  overflow: hidden !important;
  top: 30px !important;
}
.media-modal-container .ant-modal-content,
.media-model-detail-file .ant-modal-content {
  background-color: #f5f5f5 !important;
}
.media-modal-container .ant-modal-content .ant-modal-header,
.media-model-detail-file .ant-modal-content .ant-modal-header {
  background-color: #f5f5f5 !important;
}
.file-media-selected .card-file-item {
  border: 2px solid #1677ff;
}
.select-multiple-file-container {
  margin-bottom: 24px;
}
.select-multiple-file-container .file-selected {
  border-radius: 6px;
  border: 1px solid #d9d9d9;
}
.select-multiple-file-container .file-selected .file-selected-view {
  padding: 20px;
  overflow: auto;
}
.select-multiple-file-container .file-selected .file-selected-view .image-view-item {
  height: 130px;
  overflow: hidden;
  position: relative;
}
@media (max-width: 565px) {
  .select-multiple-file-container .file-selected .file-selected-view .image-view-item {
    height: 90px;
  }
}
.select-multiple-file-container .file-selected .file-selected-view .image-view-item .image-ant {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #d9d9d9;
}
.select-multiple-file-container .file-selected .file-selected-view .image-view-item .image-ant image {
  max-width: 100%;
  max-height: 100%;
}
.select-multiple-file-container .file-selected .file-selected-view .image-view-item .close-image-view {
  position: absolute;
  z-index: 100;
  top: -1px;
  right: 4px;
  color: #23282D;
  font-size: 20px;
  cursor: pointer;
  opacity: 0;
  visibility: hidden;
  transition: 0.3s;
  color: #ff4d4f;
}
.select-multiple-file-container .file-selected .file-selected-view .image-view-item:hover .close-image-view {
  visibility: visible;
  opacity: 1;
}
.select-multiple-file-container .file-selected .file-selected-control {
  padding: 12px 20px;
  border-top: 1px solid #d9d9d9;
}
.select-multiple-file-container .ant-form-item-control-input {
  min-height: unset !important;
}
.select-single-file-container {
  position: relative;
  margin-bottom: 24px;
}
.select-single-file-container .card-file-single-cover {
  display: flex;
  padding: 10px;
}
.select-single-file-container .card-file-single-cover img {
  max-width: 200px;
}
.select-single-file-container .action-file-single {
  position: absolute;
  top: 0;
  right: 0;
  font-size: 25px;
  opacity: 0;
  visibility: hidden;
  transition: 0.3s;
  z-index: 100;
  line-height: 25px;
}
.select-single-file-container:hover .action-file-single {
  opacity: 1;
  visibility: visible;
}
.select-single-file-container .ant-form-item-control-input {
  min-height: unset !important;
}
.loading-data-main {
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}
.lazy-loading-main {
  width: 100%;
  height: 280px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.date-picker-input {
  width: 100%;
}
.ant-notification-topRight {
  z-index: 10000000000;
}
.my-message-cms-top {
  z-index: 10000000000;
}
.ant-message {
  z-index: 10000000000 !important;
}
`, "",{"version":3,"sources":["webpack://./src/styles/pages/login.less","webpack://./src/styles/styles.less","webpack://./src/styles/components/user-dropdown.less","webpack://./src/styles/components/header-content.less","webpack://./src/styles/components/card-media-item.less","webpack://./src/styles/components/select-file-media.less"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;ACCF;ADPA;EAQI,YAAA;EACA,cAAA;ACEJ;ADXA;EAYI,gBAAA;ACEJ;ADEA;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;EACA,cAAA;ACAF;ACrBA;EACE,eAAA;ADuBF;ACxBA;EAGI,cAAA;EACA,SAAA;ADwBJ;ACvBI;EAAA;IACE,WAAA;ED0BJ;AACF;AEjCA;EACE,oBAAA;AFmCF;AGpCA;EACE,gBAAA;EACA,eAAA;AHsCF;AGxCA;EAII,WAAA;EACA,gBAAA;AHuCJ;AG5CA;EAOM,wBAAA;AHwCN;AGnCA;EACE,gBAAA;AHqCF;AGtCA;EAGI,mBAAA;EACA,uBAAA;AHsCJ;AG1CA;EAOI,aAAA;EACA,WAAA;EACA,eAAA;EACA,wBAAA;AHsCJ;AGlCA;EACE,sBAAA;EACA,uBAAA;AHoCF;AGtCA;EAII,WAAA;EACA,YAAA;AHqCJ;AG1CA;EAQI,eAAA;EACA,cAAA;AHqCJ;AG9CA;EAYI,aAAA;EACA,WAAA;EACA,eAAA;EACA,wBAAA;AHqCJ;AGjCA;EAEI,2BAAA;EACA,cAAA;AHkCJ;AG7BA;;EACE,sBAAA;EACA,2BAAA;EACA,oBAAA;AHgCF;AGnCA;;EAKI,oCAAA;AHkCJ;AGvCA;;EAOM,oCAAA;AHoCN;AG/BA;EAEI,yBAAA;AHgCJ;AInGA;EACE,mBAAA;AJqGF;AItGA;EAGI,kBAAA;EACA,yBAAA;AJsGJ;AI1GA;EAMM,aAAA;EACA,cAAA;AJuGN;AI9GA;EASQ,aAAA;EACA,gBAAA;EACA,kBAAA;AJwGR;AIvGQ;EAAA;IACE,YAAA;EJ0GR;AACF;AIxHA;EAgBU,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;AJ2GV;AIhIA;EAuBY,eAAA;EACA,gBAAA;AJ4GZ;AIpIA;EA4BU,kBAAA;EACA,YAAA;EACA,SAAA;EACA,UAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;EACA,UAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;AJ2GV;AIzGQ;EAEI,mBAAA;EACA,UAAA;AJ0GZ;AIrJA;EAiDM,kBAAA;EACA,6BAAA;AJuGN;AIzJA;EAsDI,4BAAA;AJsGJ;AIlGA;EACE,kBAAA;EACA,mBAAA;AJoGF;AItGA;EAII,aAAA;EACA,aAAA;AJqGJ;AI1GA;EAOM,gBAAA;AJsGN;AI7GA;EAWI,kBAAA;EACA,MAAA;EACA,QAAA;EACA,eAAA;EACA,UAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,iBAAA;AJqGJ;AInGE;EAEI,UAAA;EACA,mBAAA;AJoGN;AI5HA;EA6BI,4BAAA;AJkGJ;AAtLA;EACE,WAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAwLF;AArLA;EACE,WAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAuLF;AApLA;EACE,WAAA;AAsLF;AApLA;EACE,oBAAA;AAsLF;AApLA;EACE,oBAAA;AAsLF;AApLA;EACE,+BAAA;AAsLF","sourcesContent":[".login-container {\n  width: 100%;\n  height: 100vh;\n  background: #0a131d;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  .login-boxer {\n    width: 380px;\n    max-width: 90%;\n  }\n  .logo {\n    max-width: 250px;\n  }\n}\n\n.login-ft {\n  position: absolute;\n  bottom: 15px;\n  right: 15px;\n  z-index: 1;\n  color: #ffffff;\n}\n","@import './pages';\n@import './components';\n\n.loading-data-main {\n  width: 100%;\n  height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.lazy-loading-main {\n  width: 100%;\n  height: 280px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.date-picker-input {\n  width: 100%;\n}\n.ant-notification-topRight{\n  z-index: 10000000000;\n}\n.my-message-cms-top {\n  z-index: 10000000000;\n}\n.ant-message {\n  z-index: 10000000000 !important;\n}\n",".user-dropdown {\n  cursor: pointer;\n  .user-label{\n    color: #ffffff;\n    margin: 0;\n    @media(max-width: 576px) {\n      width: 40px;\n    }\n  }\n}\n",".header-content-main{\n  padding-bottom: 10px;\n}\n",".card-folder-item {\n  overflow: hidden;\n  cursor: pointer;\n  .folder-item-container {\n    width: 100%;\n    overflow: hidden;\n    .folder-item-name {\n      width: calc(100% - 25px);\n    }\n  }\n}\n\n.card-file-item {\n  overflow: hidden;\n  .card-cover {\n    object-fit: contain;\n    object-position: center;\n  }\n  .card-cover-dox {\n    height: 100px;\n    width: 100%;\n    font-size: 60px;\n    display: flex !important;\n  }\n}\n\n.skeleton-file-media {\n  width: 100% !important;\n  height: 100% !important;\n  .card-file-item {\n    width: 100%;\n    height: 100%;\n  }\n  .card-cover-dox {\n    font-size: 60px;\n    color: #bfbfbf;\n  }\n  .card-cover-dox {\n    height: 100px;\n    width: 100%;\n    font-size: 60px;\n    display: flex !important;\n  }\n}\n\n.attachment-detail-container {\n  .attachment-info {\n    height: calc(100vh - 250px);\n    overflow: auto;\n  }\n}\n\n\n.media-modal-container,.media-model-detail-file {\n  height: 96% !important;\n  overflow: hidden !important;\n  top: 30px !important;\n  .ant-modal-content {\n    background-color: #f5f5f5 !important;\n    .ant-modal-header {\n      background-color: #f5f5f5 !important;\n    }\n  }\n}\n\n.file-media-selected {\n  .card-file-item {\n    border: 2px solid #1677ff;\n  }\n}\n\n.file-media-not-selected{}\n",".select-multiple-file-container{\n  margin-bottom: 24px;\n  .file-selected{\n    border-radius: 6px;\n    border: 1px solid #d9d9d9;\n    .file-selected-view{\n      padding: 20px;\n      overflow: auto;\n      .image-view-item {\n        height: 130px;\n        overflow: hidden;\n        position: relative;\n        @media(max-width: 565px){\n          height: 90px;\n        }\n        .image-ant {\n          width: 100%;\n          height: 100%;\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          background-color: #d9d9d9;\n          image {\n            max-width: 100%;\n            max-height: 100%;\n          }\n        }\n        .close-image-view{\n          position: absolute;\n          z-index: 100;\n          top: -1px;\n          right: 4px;\n          color: #23282D;\n          font-size: 20px;\n          cursor: pointer;\n          opacity: 0;\n          visibility: hidden;\n          transition: .3s;\n          color: #ff4d4f;\n        }\n        &:hover {\n          .close-image-view{\n            visibility: visible;\n            opacity: 1;\n          }\n        }\n      }\n    }\n    .file-selected-control{\n      padding: 12px 20px;\n      border-top: 1px solid #d9d9d9;\n    }\n  }\n  .ant-form-item-control-input {\n    min-height: unset !important;\n  }\n}\n\n.select-single-file-container{\n  position: relative;\n  margin-bottom: 24px;\n  .card-file-single-cover {\n    display: flex;\n    padding: 10px;\n    img{\n      max-width: 200px;\n    }\n  }\n  .action-file-single {\n    position: absolute;\n    top: 0;\n    right: 0;\n    font-size: 25px;\n    opacity: 0;\n    visibility: hidden;\n    transition: .3s;\n    z-index: 100;\n    line-height: 25px;\n  }\n  &:hover{\n    .action-file-single{\n      opacity: 1;\n      visibility: visible;\n    }\n  }\n\n  .ant-form-item-control-input {\n    min-height: unset !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
